import { useEffect, useRef } from 'react';

/**
 * [B-2 단위 3] 공용 영상 타일 부품
 * - 내 영상 / 상대 영상 / 단체 공용
 * - 요소 재생성 없이 className / props 로만 보임·크기·위치 전환
 * - 소리는 숨김 audio 전담이므로 video 는 항상 muted={true} 강제
 * - 트랙 stop 금지 (엔진이 관리)
 */
export default function VideoTile({ stream = null, mirrored = false, className = '' }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (stream) {
      video.srcObject = stream;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch((err) => {
          if (err?.name === 'AbortError') {
            /* 의도적 무시: 스트림 교체·언마운트 시 브라우저 정상 재생 중단 */
            return;
          }
          if (import.meta.env.DEV) {
            console.warn('[VideoTile] play() rejected:', err);
          }
        });
      }
    } else {
      video.srcObject = null;
    }

    return () => {
      if (video) {
        video.srcObject = null;
      }
    };
  }, [stream]);

  // [C-9] 화면 복귀 시 영상 멈춤 해소 (visibilitychange visible 시 paused 이면 play 재호출)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const video = videoRef.current;
        if (video && stream && video.paused) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch((err) => {
              if (err?.name === 'AbortError') return;
              if (import.meta.env.DEV) {
                console.warn('[VideoTile] 복귀 시 play() rejected:', err);
              }
            });
          }
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [stream]);

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted
      disablePictureInPicture
      className={`object-cover ${className}`}
      style={mirrored ? { transform: 'scaleX(-1)' } : undefined}
    />
  );
}
